<template>
  <modal @close="$emit('close')">
    <template slot="header">
      Domain -
      <template v-if="form._id">edit</template>
      <template v-if="!form._id">add new</template>
    </template>
    <fieldset class="mb-3" :class="{ 'loading-mask': ready > 0 }">
      <div class="form-group row">
        <label class="col-form-label col-lg-4">Domain without subdomain (like bbc.com)</label>
        <div class="col-lg-4">
          <input type="text" class="form-control" v-model="form.domain">
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-4">Choose Mailgun account</label>
        <div class="col-lg-4">
          <div class="form-check form-check-inline">
            <multiselect v-model="form.mailer_account" tag-placeholder="" placeholder="Search for a Mailgun account"
              label="name" track-by="id" :options="mailgun_acc || []" :multiple="false"></multiselect>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-4">Choose GoDaddy account</label>
        <div class="col-lg-4">
          <div class="form-check form-check-inline">
            <multiselect v-model="form.domain_account" tag-placeholder="" placeholder="Search for a Godaddy account"
              label="name" track-by="id" :options="godaddy_acc || []" :multiple="false"></multiselect>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-form-label col-lg-3">Subdomains</label>
        <div class="col-lg-2 col-offset-2">
          <span @click="addEmptySubdomain" style="margin-top:5px; cursor: pointer" class="badge badge-primary"><i
              class="icon icon-add"></i>
            Add subdomain
          </span>
        </div>
        <div class="col-lg-2 col-offset-2">
          <input type="number" min="0" v-model="default_subdomains_count" class="form-control" />
          <span @click="addDefaultSubdomains" style="margin-top:5px; cursor: pointer" class="badge badge-primary"><i
              class="icon icon-add"></i>
            Load default subdomains
          </span>
        </div>
        <div class="col-lg-4"></div>
        <template v-for="h, k in form.subdomains">
          <label class="col-form-label col-lg-4" v-if="k > 0"></label>
          <div class="col-lg-6">
            <input type="text" class="form-control" placeholder="Subdomain or empty to add root domain"
              v-model="form.subdomains[k].subdomain">
          </div>
          <div class="col-lg-1">
            <span @click="removeSubdomain($event, k)" style="margin-top:7px" class="badge bg-danger"
              v-tooltip="'Remove subdomain'"><i class="icon icon-close2"></i></span>
          </div>
        </template>
      </div>
      <div class="alert alert-danger" v-if="err">{{ err }}</div>
      <div class="form-group row">
        <label class="col-form-label col-lg-12">
          <button type="button" class="btn btn-primary" @click="save()">Save</button>
          <button class="btn btn-link" @click="$emit('close')">Cancel</button>
        </label>
      </div>
    </fieldset>
  </modal>
</template>
<script>
import modal from '../common/Modal.vue'

export default {
  components: { modal },
  props: {
    id: null,
  },
  data() {
    return {
      form: {
        id: null,
        domain: null,
        mailer_account: null,
        domain_account: null,
        subdomains: []
      },
      err: null,

      mailgun_acc: [],
      godaddy_acc: [],
      default_subdomains: [],
      default_subdomains_count: 0,

      ready: 3
    }
  },
  methods: {
    removeSubdomain(_, k) {
      this.form.subdomains.splice(k, 1)
    },
    addEmptySubdomain() {
      this.form.subdomains.push({ subdomain: '' })
    },
    addDefaultSubdomains() {
      let i = this.default_subdomains_count

      if (this.default_subdomains_count > this.default_subdomains.length) {
        i = this.default_subdomains.length
      }

      let ii = 0
      while (i > 0) {
        ii++
        if (this.default_subdomains_count < this.form.subdomains.length) {
          // return
        }
        var item = this.default_subdomains[Math.floor(Math.random() * this.default_subdomains.length)];

        let isPicked = this.form.subdomains.filter(s => s.subdomain === item).length > 0

        if (!isPicked) {
          this.form.subdomains.push({ subdomain: item })
          i--
        }

        if (ii > 100) {
          return
        }
      }
    },
    load() {
      this.$api.getReq('accounts/godaddy').then(res => {
        this.godaddy_acc = res.body.data

        this.ready--
      })

      this.$api.getReq('accounts/mailgun').then(res => {
        this.mailgun_acc = res.body.data
        this.ready--
      })
    },
    save() {

      this.err = null

      if (!this.form.mailer_account) {
        this.err = 'Choose Mailgun account'
        return
      }

      if (!this.form.domain_account) {
        this.err = 'Choose Godaddy account'
        return
      }

      let f = JSON.parse(JSON.stringify(this.form))
      f.mailer_account = f.mailer_account._id
      f.domain_account = f.domain_account._id

      this.$api.postReq('domain', f).then(res => {
        this.$emit('close')
        this.$emit('reload')
      }).catch(res => {
        this.err = res.body.error
      })
    },
    loadDefaultSubdomains() {
      this.$api.getReq('settings').then(res => {
        (res.body.data.default_subdomains || []).forEach(s => {
          this.default_subdomains.push(s.value)
        })
        this.ready--
      })
    },
  },
  mounted() {

    this.load()
    this.loadDefaultSubdomains()

    if (typeof this.id !== 'string') {
      return
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/DomainMailgun.vue